<div class="modal-header">
  <h5 class="modal-title">Select Practice</h5>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p class="mb-2">Please choose a patient from the practice to generate the patient link for.</p>

  <div class="list-group practice-list">
  <label
    *ngFor="let p of practices"
    class="practice-item list-group-item list-group-item-action d-flex align-items-center"
    [class.selected]="selectedId === p.uniq_id"
    (click)="select(p)"
  >
    <div class="practice-avatar">{{ (p.first_name + p.last_name) | slice:0:1 }}</div>
    <div class="practice-info flex-grow-1 ml-3">
      <div class="practice-title">{{ p.first_name }} {{ p.last_name }} - {{ p.practice_map.practice.practice_name }}</div>
    </div>
  </label>
</div>
</div>
